import { controls,grouped } from "../controls";
const assign_portal_to_talathis = {
label: "Assign Portal To Talathis",
pageLabel: "Assign Portal To Talathis",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Taluka",star:false}),
...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code",fastpath: "talukas" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display"}),
...controls.displayText({ tab: "general", label: "Portal",star:true}),
...controls.oc({ tab: "general", c: "Portal", placeHolder: "Portal Code", name: "portal_code",isRequired:true,fastpath: "portals" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "portal_display"}),
...controls.displayText({ tab: "general", label: "Portal Scheme",star:true}),
...controls.oc({ tab: "general", c: "PortalScheme", placeHolder: "Portal Scheme Code", name: "portal_scheme_code",isRequired:true,fastpath: "portal_schemes",autoopen:true ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "portal_scheme_display"}),
]
,history:{
perPage: 10,
reportHeader: "Assign Portal To Talathis",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Taluka",accessor: "AssignPortalToTalathi-taluka-taluka_display",},
{Header: "Portal",accessor: "AssignPortalToTalathi-portal-portal_display",},
{Header: "Portal Scheme",accessor: "AssignPortalToTalathi-portal_scheme-portal_scheme_display",},
]}};
export default assign_portal_to_talathis;